<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title"> Статистика</h3>
            </div>

            <div class="row">


              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title"> Продажи по месяцам</h3>
                  </div>
                  <div class="card-body small">
                    <Bar2 :chart-data="chartData" ></Bar2>
                    {{sales_m}}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title"> Выручка за текущий месяц </h3>
                  </div>
                  <div class="card-body">
                    <Bar :chart-data="chartDataDay"></Bar>

                </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Популярные позиции</h3>
                  </div>
                  <div class="card-body">

                  </div>
                  </div>
              </div>

              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title"> Продажи</h3>
                  </div>
                  <div class="card-body">
                  <br>
                  &ensp; Заказов за сегодня <b style="color: #064cd6">{{results.daycount}}</b> шт на <b style="color: #b43cc4">{{results.sale_day}}</b> руб.<br>
                  &ensp; Заказов на завтра <b style="color: #064cd6">{{results.daycountfut}}</b> шт на <b style="color: #b43cc4">{{results.sale_dayfut}}</b> руб.<br>
                  &ensp; Заказов на послезавтра <b style="color: #064cd6">{{results.daycountfut2}}</b> шт на <b style="color: #b43cc4">{{results.sale_dayfut}}</b> руб.<br>
                  &ensp; Заказов за неделю <b style="color: #064cd6">{{results.weekcount}}</b> шт на <b style="color: #b43cc4">{{results.sale_week}}</b> руб.<br>
                  <br>
                  &ensp; Заказов от магазинов <font style="color: #064cd6">{{results.monthcountus}}</font> шт на <font style="color: #b43cc4">{{results.sale_month_user}}</font> руб.<br>
                  &ensp; Заказов от клиентов <font style="color: #064cd6">{{results.monthcountfil}}</font> шт на <font style="color: #b43cc4">{{results.sale_month_fil}}</font> руб.<br>
                  &ensp; Заказов за месяц <font style="color: #064cd6">{{results.monthcount}}</font> шт на <font style="color: #b43cc4">{{results.sale_month}}</font> руб.<br>
                  <br>
                  &ensp; За прошлый месяц <font style="color: #064cd6">{{results.prewmonthcount}}</font> шт на <font style="color: #b43cc4">{{results.sale_prewmonth}}</font> руб.<br>
                  <br>
                  &ensp; Средний чек за день<font style="color: #064cd6"> {{Math.round(results.medium_day)}}</font> руб.<br>
                </div>
                </div>
              </div>
              <div class="col-8">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title"> Список изменений
                    </h3>
                  </div>
                  <div class="card-body">
                  <b>20.01.2023</b> Переписал фронт на vue<br>
                  <b>10.08.2023</b> Переписал бэк, оптимизировал запрсы<br>
                  <b>17.09.2020</b> Сделал корзину для удаленных заказов(пока черновик)<br>
                  <b>15.08.2020</b> Сумма за день<br>
                  <b>06.02.2020</b> Поправил редактирование заказа<br>
                  <b>05.02.2020</b> В тестовом режиме готов прием заказов от клиентов<br>
                  <b>04.02.2020</b> Поправил ввод времени при создании заказа<br>
                  <b>28.01.2020</b> Немного доработал статистику<br>
                  <b>25.01.2020</b> Поправил редактирование заказа<br>
                  <b>17.01.2020</b> Поправил вывод заказчика при печати<br>
                  <b>15.01.2020</b> Поправил вывод поля 'Филилал' в редактировании заказа<br>
                  <b>14.01.2020</b> Сделал поиск в каталоге продукции<br>
                  <b>14.01.2020</b> Исправил расчет суммы заказов в статистике<br>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import { Bar } from 'vue-chartjs/legacy'
 import { Bar as Bar2 } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, BarElement, CategoryScale, LinearScale,PointElement,LineElement)

export default {
  components: {
    Bar,Bar2,
  },
  data() {
    return {
      chartDataDay: {
        labels: [],
        datasets: [
          {
            label: 'Выручка',
            backgroundColor: '#1f84f1',
            data: []
          }
        ]
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Выручка',
            backgroundColor: '#1f84f1',
            data: []
          },
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      results: [],
      options: [],
      price: 0,
      prices: [],
      urls: {
        data: "/api/home/",
      }
    };
  },
  methods: {
    getData(){
      axios.get(this.urls.data).then(({data}) => (this.results = data.data));
    },

  },
  created() {
    this.$Progress.start();
  //  this.getData();
    this.$Progress.finish();
  },
  computed: {
    sales_m: function () {
      if (this.results.month ){
        this.chartData.datasets[0].data=this.results.month;
        this.chartDataDay.datasets[0].data=this.results.countmoutday;
        console.log(this.results.countmoutday);
        console.log(this.results.month);
      }
      return '';
    }
  }
}
</script>

<style>
.search {
  position: relative;
}

.search_form {
  z-index: 700;
  position: absolute;
  inset: 0px auto auto 11px;
  transform: translate3d(0em, 4em, 0px);
}

.search_result {
  background: #FFF;
  border: 1px #ccc solid;
  width: auto;
  border-radius: 1em;
  max-height: 15em;
  overflow-y: scroll;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  box-shadow: rgb(0 145 228 / 9%) 7px 7px 0px 1px;
}

.search_result li {
  list-style: none;
  padding: 5px 10px;
  margin: 0 0 0 0px;
  color: #4f5558;
  border-bottom: 1px #ccc solid;
  cursor: pointer;
  /*text-align: left;*/
  transition: 0.3s;
}

.search_result li:hover {
  background: #8cbfd4;
  color: white;
}

.search_result li:active {
  background: #51b1e3;
  color: white;
}



.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.col-md-6, .col-md-12 {
  padding-top: 0px;
  padding-right: 12px;
  padding-bottom: 0px;
  padding-left: 12px;
}

.small {
  /*max-width: 24em;*/
  /*margin:  15px auto;*/
}


</style>
